export default __webpack_public_path__ + "static/media/pool2.987d8d12.jpeg";